import React, {useState, useEffect, useRef} from "react";
import styled from "styled-components";
import cx from "classnames";

const MatrixOptionContainer = styled.div`
  padding-bottom: 2.3rem;
`;

const RadioButton = styled.div`
  min-width: 1rem;
`;

const formatOptions = (options, sorted) => {
  if (sorted) {
    return options.sort((a, b) =>
      a ? a.toLowerCase() : "" > b ? b.toLowerCase() : "" ? 1 : -1
    );
  }
  if (!sorted) {
    return options;
  }
};

const verticalSorted = (options) => {
  const len = options.length;
  const limit = len % 2 === 0 ? len / 2 : len / 2 + 1;
  const left = options.slice(0, limit);
  const right = options.slice(limit, len);
  let newOptions = [];
  for (let i = 0; i < left.length; i++) {
    newOptions.push(left[i]);
    if (i < right.length) newOptions.push(right[i]);
  }
  return newOptions;
};

const MatrixOptions = ({
  title,
  options = [],
  border = false,
  onChange = () => {},
  selectedOptions = [],
  sorted = false,
  availableOptions = [],
}) => {
  const handleChange = (option) => {
    if (availableOptions.includes(option.replace(/\s/g, ""))) {
      if (selectedOptions.includes(option)) {
        onChange(selectedOptions.filter((c) => c !== option));
      } else {
        onChange([...selectedOptions, option]);
      }
    }
  };

  const formattedOptions = formatOptions(options, sorted);
  const filteredOptions = formattedOptions.filter((o) => o);
  const filteredOptionsSorted = verticalSorted(filteredOptions);

  const [lastPressedButton, setLastPressedButton] = useState("");
  const announcementRef = useRef(null);
 
  useEffect(() => {
    if (lastPressedButton) {
      announcementRef.current.textContent = `${lastPressedButton}`;
    }
  }, [lastPressedButton]);

  return (
    <MatrixOptionContainer
      className={cx("pt-8 flex flex-col w-full", {
        "border-b border-action-blue": border,
      })}
    >
      <span className="text-action-blue text-2xl mb-3 font-trade-gothic-20">
        {title}
      </span>
      <div className="w-full grid grid-cols-2">
        {filteredOptionsSorted.map((option) => (
          <button
            className={cx(
              "w-full mb-2 relative flex justify-start leading-5 items-center tracking-normal text-sm",
              {
                "pointer-events-none opacity-50": !availableOptions.includes(
                  option.replace(/\s/g, "")
                ),
              }
            )}
            key={option}
            onClick={() => {
              handleChange(option)
              setLastPressedButton(`${option} ${title} ${!selectedOptions.includes(option) ? "checked" : ""}`)
            }}
            aria-label={
              option
                ? option + " " + `${title}` +
                  (availableOptions.includes(option.replace(/\s/g, ""))
                    ? ""
                    : " option disabled")
                : ""
            }
            disabled={!availableOptions.includes(option.replace(/\s/g, ""))}
            role="checkbox"
            aria-checked={selectedOptions.includes(option)}
            aria-hidden={selectedOptions.includes(option)}
          >
            <RadioButton
              className={cx("w-4 h-4 mr-2 rounded-full", {
                "bg-action-blue": selectedOptions.includes(option),
                "border-2 border-action-blue": !selectedOptions.includes(
                  option.replace(/\s/g, "")
                ),
                "border-2 border-mattamy-search-gray": !availableOptions.includes(
                  option.replace(/\s/g, "")
                ),
              })}
            />
            <span
              className={cx("font-graphie text-left md:pr-2", {
                "text-mattamy-search-gray": !availableOptions.includes(
                  option.replace(/\s/g, "")
                ),
                "text-action-blue": availableOptions.includes(
                  option.replace(/\s/g, "")
                ),
              })}
            >
              {option}
            </span>
          </button>
        ))}
      </div>
      <div
        aria-live="polite"
        aria-atomic="true"
        ref={announcementRef}
        style={{ position: "absolute", left: "-9999px" }}
      />
    </MatrixOptionContainer>
  );
};

export default MatrixOptions;
